import { IApplicationState } from '../../types/redux';

export const selectListNumber = (state: IApplicationState) => state.analytic.listNumber;
